<template>
  <i
    :class="['v-icon', iconName, iconVariant, iconSize]"
    :style="iconStyles"
    @click="clicked"
  />
</template>

<script>
const icons = Object.freeze({
  CHEVRON_UP: "chevron-up",
  CHEVRON_RIGHT: "chevron-right",
  CHEVRON_DOWN: "chevron-down",
  CHEVRON_LEFT: "chevron-left",
  LOCK: "lock",
  PIN: "pin",
  FILE_TEXT: "file-text",
  PROFILE_CARD: "profile-card",
  HOSPITAL: "hospital",
  PLUS: "plus",
  CROSS: "cross",
  SEARCH: "search",
  CHECK_CIRCLE: "check-circle",
  EYE: "eye",
  EYE_SLASH: "eye-slash",
  DEFAULT: ""
});

const variants = Object.freeze({
  PRIMARY: "primary",
  SECONDARY: "secondary",
  SUCCESS: "success",
  DANGER: "danger",
  WARNING: "warning",
  INFO: "info",
  DEFAULT: ""
});

const sizes = Object.freeze({
  SM: "sm",
  MD: "md",
  LG: "lg",
  XL: "xl",
  XS: "xs"
});

export default {
  name: "BaseIcon",
  props: {
    icon: {
      type: String,
      validator: value => Object.values(icons).includes(value),
      default: icons.DEFAULT
    },
    variant: {
      type: String,
      validator: value => Object.values(variants).includes(value),
      default: variants.DEFAULT
    },
    size: {
      type: String,
      validator: value => Object.values(sizes).includes(value),
      default: sizes.MD
    },
    color: {
      type: String,
      default: ""
    }
  },
  methods: {
    clicked() {
      this.$emit("click");
    }
  },
  computed: {
    iconName() {
      return this.icon ? `v-icon-${this.icon}` : "";
    },
    iconVariant() {
      return this.variant ? `v-icon-${this.variant}` : "";
    },
    iconSize() {
      return `v-icon-${this.size}`;
    },
    iconStyles() {
      return {
        backgroundColor: this.color
      };
    }
  }
};
</script>
